import { Component, OnInit, Input } from '@angular/core';
import { UserQuery } from '@ep-om/project/state/user/user.query';
import { Observable } from 'rxjs';

@Component({
  selector: 'om-debug',
  templateUrl: './om-debug.component.html',
  styleUrls: ['./om-debug.component.scss']
})
export class OmDebugComponent implements OnInit {

  @Input() title: string = "debug";
  @Input() data: object = {};

  amISysAdmin$: Observable<boolean>;

  constructor(
    private userQuery: UserQuery,
  ) {
    this.amISysAdmin$ = this.userQuery.amIGlobalSysAdmin$;
  }

  ngOnInit(): void { }

}
